import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=0f6dfd5e&scoped=true&"
import script from "./structure.vue?vue&type=script&lang=js&"
export * from "./structure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6dfd5e",
  null
  
)

export default component.exports